import { Image } from "./image";
import React, { useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CustomPrevArrow = (props) => {
  const { onClick } = props;
  return (
    <button
      className="custom-arrow custom-prev"
      onClick={onClick}
      aria-label="Previous slide"
    >
      <i className="fa fa-chevron-left"></i>
    </button>
  );
};

const CustomNextArrow = (props) => {
  const { onClick } = props;
  return (
    <button
      className="custom-arrow custom-next"
      onClick={onClick}
      aria-label="Next slide"
    >
      <i className="fa fa-chevron-right"></i>
    </button>
  );
};

export const Gallery = (props) => {
  const sliderRef = useRef(null);

  useEffect(() => {
    if (sliderRef.current && props.data) {
      setTimeout(() => {
        if (sliderRef.current) {
          sliderRef.current.slickGoTo(0);
        }
      }, 100);
    }
  }, [props.data]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 2,
    slidesPerRow: 2,
    lazyLoad: false,
    waitForAnimate: false,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          rows: 2,
          slidesPerRow: 2,
          lazyLoad: false,
          prevArrow: <CustomPrevArrow />,
          nextArrow: <CustomNextArrow />,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          rows: 1,
          slidesPerRow: 1,
          lazyLoad: false,
          prevArrow: <CustomPrevArrow />,
          nextArrow: <CustomNextArrow />,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          rows: 1,
          slidesPerRow: 1,
          lazyLoad: false,
          prevArrow: <CustomPrevArrow />,
          nextArrow: <CustomNextArrow />,
        },
      },
    ],
  };

  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Gold Items We Buy - Professional Appraisal Gallery</h2>
          <p>
            View our facility and the types of gold items we buy. Experience our professional, secure, and transparent gold buying process in Guwahati.
          </p>
        </div>
        <div className="carousel-wrapper">
          {props.data ? (
            <Slider ref={sliderRef} {...settings}>
              {props.data.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className="carousel-slide"
                >
                  <Image
                    title={d.title}
                    largeImage={d.largeImage}
                    smallImage={d.smallImage}
                  />
                </div>
              ))}
            </Slider>
          ) : (
            "Loading..."
          )}
        </div>
      </div>
    </div>
  );
};
